import React from 'react';
import PropTypes from 'prop-types';
import { IconUserGroup } from '../Icons';

const GroupIcon = ({ size }) => (
  <div className="flex items-center justify-center w-full h-full bg-blue-600">
    <IconUserGroup
      className="text-white fill-current max-w-three-quarters items-stretch flex-auto"
      size={size}
    />
  </div>
);

GroupIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default GroupIcon;
